import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

import firebaseConfig from "./firebaseConfig";

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
const firebaseAppAuth = firebaseApp.auth();

firebaseAppAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL).catch(() => {
  console.warn("LOCAL persistence unavailable, falling back to SESSION");
  return firebaseAppAuth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
});

firebaseApp.firestore().settings({ ignoreUndefinedProperties: true });

const db = firebaseApp.firestore();

if (import.meta.env.VITE_LOCAL === "TRUE") {
  console.log("Use firebase emulator");
  db.useEmulator("localhost", 5003);
  firebaseAppAuth.useEmulator("http://localhost:5004/");
}

export { firebaseAppAuth, firebaseApp, db };
